import { Button, CircularProgress, Tooltip } from "@mui/material";
import { LowPriority } from "@mui/icons-material";
import { FC, useState } from "react";
import MoveVirtualBatteryDialog from "./MoveVirtualBatteryDialog";
import MoveVirtualBatteryContextProvider from "./MoveVirtualBatteryContextProvider";
import { BatteryOriginWarning } from "./BatteryOriginsWarning";
import useAuth from "@/components/Authentication/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { useVirtualBatteries } from "../../hooks/useVirtualBatteries";
import { IBateriaVirtual } from "../../types/virtualBattery";

interface BateriaVirtualMoveVirtualBatteryDialogOpenButtonParams {
  bateriaVirtual: IBateriaVirtual;
}

/*
 * Button that opens or closes the dialog of virtual battery movement
 * - Has a state that sets the button in loading and disabled
 * - Has the ContextProvider needed for the virtual battery movement components
 * */
const BateriaVirtualMoveVirtualBatteryDialogOpenButton: FC<BateriaVirtualMoveVirtualBatteryDialogOpenButtonParams> = ({
  bateriaVirtual,
}) => {
  const { t } = useTranslation();
  const { 
    isBateriaVirtualActive
  } = useVirtualBatteries();
  const { tokenVals } = useAuth();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const renderButton = (
    <div>
      <Tooltip
        title={tokenVals?.readonly &&
          t("common:text.token_readonly_tooltip")
        }
        placement="right"
        arrow
        disableFocusListener={!tokenVals?.readonly}
        disableHoverListener={!tokenVals?.readonly}
        disableTouchListener={!tokenVals?.readonly}
        slotProps={{
          popper: {
            modifiers: [{
              name: 'offset',
              options: {offset: [0, -5]}
            }]
          }
        }}
      >
        <span>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={handleDialogOpen}
            disabled={!!tokenVals?.readonly || !isBateriaVirtualActive(bateriaVirtual.id)}
            startIcon={<LowPriority/>}
          >
            {t("common:text.virtual_battery_move")}
          </Button>
        </span>
      </Tooltip>

      {bateriaVirtual.es_origen ? (
        dialogOpen && <BatteryOriginWarning onAccept={() => setDialogOpen(false)}/>
      ) : (
        <MoveVirtualBatteryContextProvider>
          <MoveVirtualBatteryDialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            bateriaVirtual={bateriaVirtual}
          />
        </MoveVirtualBatteryContextProvider>
      )}
    </div>
  );

  if (!isBateriaVirtualActive(bateriaVirtual.id)) {
    return (
      <Tooltip title={t('common:text.virtual_battery_not_actived_because_of_dates')}>
        {renderButton}
      </Tooltip>
    );
  }
  return renderButton;
};

export default BateriaVirtualMoveVirtualBatteryDialogOpenButton;
